import hotToast, { ToastOptions } from 'react-hot-toast';
import { Icon } from "@fluentui/react";

export const notify = {
  error: (message: any, options?: ToastOptions) => {
    hotToast.error(message, options);
  },
  warning: (message: any, options?: ToastOptions) => {
    hotToast(message, {
      icon:  <Icon iconName="Error" styles={{ root: { fontSize: '1.4rem', color: 'var(--theme-palette-warn-default)' } }} />,
      ...options,
    });
  },
  success: (message: any, options?: ToastOptions) => {
    hotToast.success(message, options);
  },
};
